export default {
  By: 'Por',
  and: 'e',
  htmlLabel: 'O que você está comprando',
  installments: 'Em até',
  of: 'de',
  inCash: 'à vista',
  discount: 'de desconto',
  summary: 'Resumo da compra',
  Subtotal: 'Subtotal',
  Total: 'Total',
  Discounts: 'Descontos',
  Credits: 'Créditos aplicados',
  Free: 'Grátis',
  CouponDiscount: 'Possui cupom de desconto?',
  Coupon: {
    Errors: {
      generic: 'Código inválido ou expirado',
      2000: 'Código inválido ou expirado',
      2001: 'Você já possui um desconto superior ao do cupom aplicado nessa oferta!',
      2002: 'Este cupom não é válido para essa oferta.',
      1203: 'Cupom já utilizado.'
    }
  },
  renew: {
    htmlLabel: 'O que você está renovando',
    summary: 'Resumo da renovação',
  },
};
